import { fetchCognitoOidcMetadata } from "./fetchCognitoOidcMetadata";

const normalizedPathname = (pathname: string): string =>
  pathname.replace(/\/$/, "") || "/";

const isTrustedRpLogoutEndpoint = (endSessionEndpoint: string): boolean => {
  let pathname: string;
  try {
    pathname = normalizedPathname(new URL(endSessionEndpoint).pathname);
  } catch {
    return false;
  }
  return pathname.endsWith("/logout") || pathname.endsWith("/oauth2/logout");
};

export const buildCognitoLogoutUrl = async (
  authority: string,
  clientId: string,
  logoutUri: string = window.location.origin,
): Promise<string> => {
  const meta = await fetchCognitoOidcMetadata(authority);
  const normalizedLogoutUri = new URL(logoutUri).origin;
  const end = meta.end_session_endpoint;
  if (end != null && end !== "" && isTrustedRpLogoutEndpoint(end)) {
    const u = new URL(end);
    u.searchParams.set("client_id", clientId);
    u.searchParams.set("logout_uri", normalizedLogoutUri);
    return u.toString();
  }
  const authHost = new URL(meta.authorization_endpoint);
  const logout = new URL("/logout", `${authHost.protocol}//${authHost.host}`);
  logout.searchParams.set("client_id", clientId);
  logout.searchParams.set("logout_uri", normalizedLogoutUri);
  return logout.toString();
};
